<template>
<div>
  <v-form
    class="mx-10 mb-10 pa-10 text-center"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-5 text-primary">Initialize</h3>
    <v-layout>
      <v-flex md4>
        <v-text-field
          background-color="rgba(255,255,255)"
          v-model="urls"
          label="URLs"
          dense
          outlined
        ></v-text-field>
        <v-text-field
          background-color="rgba(255,255,255)"
          v-model="accessToken"
          label="Access Token"
          @change="updateRequest"
          :rules="[v => !!v || 'You must enter the access token or click “Generate Access Token” to generate one!']"
          required
          outlined
          clearable
          dense
        ></v-text-field>
        <v-text-field
          background-color="rgba(255,255,255)"
          v-model="timeout"
          label="Timeout"
          :rules="[v => !!v || 'You must enter the timeout or click “Generate Access Token” to generate one!']"
          required
          outlined
          clearable
          dense
        ></v-text-field>
        <v-btn class="mb-5"
            :disabled="valid"
            color="primary"
            @click="dialog = !dialog"
            style="color:white"
            x-small>
          Compose AccessToken
        </v-btn>
        <v-divider></v-divider>
        <v-textarea
            background-color="#999999"
            name="input-7-1"
            label="Parameters"
            class="mt-10"
            no-resize
            height="400px"
            v-model="requestPayload"
            outlined
        ></v-textarea>

      </v-flex>
      <v-flex md2>
        <v-btn
            :disabled="!valid"
            color="primary"
            class="mb-5"
            @click="createInstance()"
            style="color:white">
          Create Instance >>
        </v-btn>
        <v-btn
            :disabled="!valid"
            color="primary"
            @click="initialize"
            style="color:white">
          Initialize >>
        </v-btn>
      </v-flex>
      <v-flex md6>
        <v-textarea background-color="rgba(255,255,255)"
                    name="input-7-1"
                    label="Response"
                    no-resize
                    height="550px"
                    v-model="response"
                    outlined
        ></v-textarea>
      </v-flex>
    </v-layout>

  </v-form>
   <v-dialog v-model="dialog" width="500" hide-overlay>
      <v-card>
        <v-card-title class="headline primary">
          <v-toolbar-title style="color:white">Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-form
          v-model="validToken">
        <v-row class="d-flex justify-center pt-8">
          <v-col cols="5" class="pr-5">
            v1:
            <v-text-field
              v-model="v1_idx"
              :rules="[v => !!v || 'You must agree to continue!']"
              label="idx"
              required
            ></v-text-field>
            <v-text-field
              v-model="v1_value"
              :rules="[v => !!v || 'You must agree to continue!']"
              label="value"
              required
            ></v-text-field>
          </v-col>
          <v-divider vertical></v-divider>
          <v-col cols="5" class="pl-5">
            v2:
            <v-text-field
              v-model="v2_idx"
              :rules="[v => !!v || 'You must agree to continue!']"
              label="idx"
              required
            ></v-text-field>
            <v-text-field
              v-model="v2_value"
              :rules="[v => !!v || 'You must agree to continue!']"
              label="value"
              required
            ></v-text-field>
          </v-col>
        </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!validToken"
            color="primary"
            text
            @click="base64"
          >
            Generate
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>
<script>

import { mapMutations } from 'vuex'
  import alisonJS from  '@/services/alison_js.js'
  export default  {
    data: () => ({
      valid:false,
      dialog: false,
      urls: "[\"https://127.0.0.1:8004\",\"https://localhost:8004\",\"https://127.0.0.1:8005\"]",
      timeout: 10000,
      accessToken: '',
      validToken: false,
      requestPayload: "",
      result: "",
      response: "",
      v1_idx: '',
      v1_value: '',
      v2_idx: '',
      v2_value: '',
    }),
    mounted(){
      this.valid = false;
      this.accessToken = 'eyJ2ZXJzaW9uIjo0LCJ2MSI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6IjMvK0RKMmsxQS9yWjQxL0hlWllYS00ydG1XazE4cDM4RXg0WDdWTWZlYXhpS3dWUHZVRTZzaUh1aHplZThHU1RMR2FwUWRXaFJRNzlyQXRqeWpRWkYxeC83Rm1ZcERzVExnTTQzdDRlV2dMV2NaclQ2Sy9uRGwvc1ltRGtLZjBjWDFtc3JHbkM4RWNQNk9KQW04RGlhUG5ZVlR0ZUpaOVEzbVNJeDk2OGU0cnpJNlF6YUh2L09FQnVmUHhMbTdpMjhQS3JBbHdSS3BQZTFVc3c4eG45NjMxRlJWc1JxaEk1WGFoamRoV2RWQnRkRmg1bE51Y1BUUDVEbFQzdkJIZy94VmV5TllOdVcvRWFobUZiS2RSRS9IRmdEOFN0cnVPTTVvNXJLSHptc2xPbnJFSi8yQkdEa1AxcnF3Nm0wZnlZUTR6K2RpYzdlTHhLWnRsNUNGWGhBR0dLOEdIYXVJVGU5RWUrQUJjN3c1WC8zZkJKVDI4VTgyOEo1V0dOZ0t6TVo5akdsbzVLNVgxOEh1cHVvZ1BGSm9nVjkyV2llbmR5c2JXMmRiZXltcVNINDBTN2kvcDdLb2pRZ2ZyNWtveHl1ZFV1cmgvK1NuYXhYOEczMTF2THU0OUNIalpmdCtycXkvRFlUZFdRS3pYYTFHanZMME5zQkIyNTFRU01OdDdoLzFSYjJkdnNMVk5HcnNKR3BjNFhMWEx1a0J6V1pXSW4zeWd1cDZUMlR0SnhzZCtPSWhtVkxhZldNbHhNME03diJ9LCJ2MiI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6ImV5SmhiR2NpT2lKU1V6STFOaUo5LmV5SnBZWFFpT2pFM05EUXpNVEkyTURVc0ltVjRjQ0k2TVRnME56Y3pOakF3TUN3aVkyOXRjR0Z1ZVU1aGJXVWlPaUpEWlhKMGFWTjFjaUJUTGtFdUlpd2lZV3hzYjNkbFpFOXlhV2RwYm5NaU9sc2lLaTVqWlhKMGFYTjFjaTVqYjIwaUxDSXFMbU5sY25ScGMzVnlMbTVsZENJc0lpb3VZMlZ5ZEdsemRYSXVhVzVtYnlJc0lpb3VkbVZ5YVhOMWNpSXNJaW91ZEc5d2RISjFjM1F1WTI5dExtRnlJaXdpS2k1elpXTjFjbVZrYjJNdWJHRWlMQ0pqYUhKdmJXVXRaWGgwWlc1emFXOXVPaTh2YTNCcWJHRm5aR3B3WVdscGJXNWxZMlJpWkdOdVpHcGphV3B2WVd4aWJHRWlMQ0l4TWpjdU1DNHdMakU2T0RBd015SXNJakV5Tnk0d0xqQXVNVG80TURBMElpd2liRzlqWVd4b2IzTjBPamd3TURNaUxDSnNiMk5oYkdodmMzUTZPREF3TkNJc0lteHZZMkZzYUc5emRDNWpaWEowYVhOMWNpNXVaWFE2T0RBNE1DSmRmUS5Gc09hel9LRWJ2WFh1dkZldXVCWExNYU42dVNjcXF2akt2Vl94dnhrUjQ2eGxuMDZyWnhTby14NElHdjcxajN0dHpERWVXUkQzUTZyV1lfeTViajR3LS0wN1dGRnM4eE8zdVpDUVdfclh3enk5TTJ2bkxIRGdtc0IyNUFPYkhTUVY3QW9iNzRZYTJRcjdlMVFQZldGallpUjlMV3hlVGV0a2dpWTluV2U2MFRoNG5sZC1mbGJSbjVVVnExQ0hqTVBiR3llc0hmSktXSkxZN001NlRIN0pKTno2Q0FNTFIwQkRlSmpodUhJN2ktMkJ2MjRzMmREMFV4Q3ZXU1RJM1piODkyc2xQMVBFdHROWGpvU2tVWVotSlU0WU1GN2tSVDZabnZmR3ZYSjdPQXdnTTFvMFRjR0Q2NGt0bXVySk00dzJoVGZXUDd3SGxXNjFoNE1aamVRcmcifX0='
      this.updateRequest();
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(){
        this.requestPayload = JSON.stringify({ accessToken: this.accessToken}, null, "\t")
      },
      base64(){
        this.dialog = false;
        const token = {v1: {idx: this.v1_idx, value: this.v1_idx}, v2: {idx: this.v2_idx, value: this.v2_value}};
        const encodeToken = window.btoa(JSON.stringify(token));
        this.accessToken = encodeToken;
      },
      createInstance() {
        try{
          alisonJS.createInstance(JSON.parse(this.urls), this.timeout);
          this.setSnack("Alison Sdk Instance created")
          this.setColor('info')
        }catch(e) {
           this.setSnack("Alison Sdk Instance creation failed")
           this.setColor('error')
        }
      },
      initialize(){
          this.$emit('disableTab')
          //const accessToken = "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"
          alisonJS.initialize(JSON.parse(this.requestPayload)).then((res)=>{
            this.result = res;
            this.response = JSON.stringify(res, null, "\t");
            this.setColor('info')
            this.setSnack("Alison Sdk initialized")
            this.$emit('enableTab', ['Sign Desktop', 'Config Manager', 'Create Credential', 'Add second factors', 'Add certificate', 'List all Certificates', 'List enabled KeyStores', 'List available Profiles', 'Initialize Profile', 'Generate CSR', 'Generate Certificate', 'Install Certificate', 'Import Certificate'])
          }, (e) => {
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
                if(e.message){ this.setSnack('ERROR ' + e.message) }
                else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.result = e;
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
<style scoped>
</style>
